import { IconProps } from "./";
import Icon from "./assets/cash_24.svg";
import { BaseIcon } from "./BaseIcon";

export function Icon24Cash(props: IconProps) {
  return <BaseIcon icon={<Icon />} {...props} />;
}
